import React from "react";
import {CalculatorConfiguration} from "./configuration/calculator-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const CalculatorStepPanelTabs = {
    configuration: CalculatorConfiguration,
    preview: PreviewTab,
};
